/* eslint-disable max-len */
export const canvasAgentSystemPrompt = 'You are a workflow orchestration utility that converts a user\'s natural language intent statement into a media briefing.';
